"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS = void 0;
const input_checkbox_1 = require("../../components/input/input.checkbox");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const tag_card_checkbox_style_1 = require("../tag.card.checkbox/tag.card.checkbox.style");
exports.CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 4;
exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS * 2 + 'px';
exports.CSS = {
    container: 'c-TagCard',
    containerLeft: 'c-TagCard__left',
    toolbar: 'c-TagCard__toolbar',
    renamejob: 'c-TagCard__renamejob',
    isHovered: 'c-TagCard--is-hovered'
};
exports.Style = {
    [exports.CSS.container]: {
        height: theme_1.DefaultTheme.space(10),
        'line-height': theme_1.DefaultTheme.space(6),
        display: 'flex',
        padding: theme_1.DefaultTheme.space(1),
        'align-items': 'center',
        'justify-content': 'center',
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.font.color.divider
        },
        [`& .${exports.CSS.toolbar}`]: {
            display: 'none'
        },
        [`&:hover .${exports.CSS.toolbar}`]: {
            display: 'flex'
        }
    },
    [exports.CSS.isHovered]: {
        backgroundColor: theme_1.DefaultTheme.font.color.divider
    },
    [exports.CSS.containerLeft]: {
        display: 'flex',
        alignItems: 'center',
        width: exports.CIRCLE_SIZE_PX,
        height: exports.CIRCLE_SIZE_PX
    },
    [exports.CSS.toolbar]: {
        display: 'flex',
        position: 'relative'
    },
    [exports.CSS.renamejob]: {
        width: theme_1.DefaultTheme.space(8),
        height: theme_1.DefaultTheme.space(8)
    },
    [`${exports.CSS.container} .${tag_card_checkbox_style_1.CSS.container}`]: {
        width: exports.CIRCLE_SIZE_PX,
        height: exports.CIRCLE_SIZE_PX
    },
    [`${exports.CSS.container} .${input_checkbox_1.CSS.container}`]: {
        marginLeft: theme_1.DefaultTheme.spacingFactor
    },
    [`${exports.CSS.container} .${spinner_1.Spinner.CSS.container}`]: {
        marginTop: theme_1.DefaultTheme.space(1)
    }
};
//# sourceMappingURL=tag.card.style.js.map